// extracted by mini-css-extract-plugin
export var isWhite = "Logo-module--isWhite--1_yc3";
export var logoWrapper = "Logo-module--logo-wrapper--RLMxi";
export var logo = "Logo-module--logo--3KiEo";
export var logoSmall = "Logo-module--logo-small--3n-sj";
export var spinAround = "Logo-module--spinAround--sQK-d";